import React from "react";
import styled from "@emotion/styled";
import { IoIosArrowBack } from "react-icons/io";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const Main = styled.div`
  display: flex;
  align-items: center;
  margin-left: 53px;

  @media (max-width: 1450px) {
    margin-left: 10px;
  }
  @media (max-width: 1415px) {
    margin-right: 129px;
  }
  @media (max-width: 1100px) {
    margin-right: 80px;
  }
`;

const Container = styled.div`
  font-size: 12px;
  font-weight: bold;
  line-height: 2;
  color: rgba(119, 121, 132, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: rgba(119, 121, 132, 1);
  }
`;

const BackArrow = styled(IoIosArrowBack)`
  cursor: pointer;
  color: inherit;
  font-size: 17px;
  margin-right: 6px;
`;

const TextSpan = styled.span`
  width: 122px;
`;

const ContinueShopping = () => {
  const pathHistory = useSelector(state => state.userInfo.pathHistory);
  const history = useHistory();

  const redirectArray = ["/", "/cart", "/checkout"];
  return (
    <Main>
      <Container
        onClick={() => {
          if (redirectArray.includes(pathHistory[pathHistory.length - 1])) {
            history.push("/buy-gift-cards/");
          } else {
            history.goBack();
          }
        }}
      >
        <BackArrow />
        <TextSpan>Continue Shopping</TextSpan>
      </Container>
    </Main>
  );
};

export default ContinueShopping;
